<template>
  <div :class="{'menu-shrink' : isMenuShrink, 'mobile-menu' : isMobileMenu}"
        class="app-drawer">
    <ul v-if="role === 'merchant'">
      <li>
        <div class="menu">
          <div class="title">
            目錄
          </div>
          <div class="close">
            <b-icon-x @click="handleMenuSlide"></b-icon-x>
          </div>
        </div>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/home">
          <div class="icon icon-home"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">主頁</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/coupons">
          <div class="icon icon-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">積分優惠券</span>
        </router-link>
      </li>
      <li v-if="user.class === 'PREMIUM'" @click="handleMenuSlide">
        <router-link to="/paidCoupons">
          <div class="icon icon-paid-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">付費優惠券</span>
        </router-link>
      </li>
      <li v-if="user.class === 'PREMIUM'" @click="handleMenuSlide">
        <router-link to="/salesorder" class="cashout level2">
          <div class="icon icon-order"></div>
          <span>銷售訂單</span>
        </router-link>
      </li>
      <li v-if="user.class === 'PREMIUM'" @click="handleMenuSlide">
        <router-link to="/paymentRecords" class="cashout level2">
          <div class="icon icon-cashout"></div>
          <span>收款狀態</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/setting">
          <div class="icon icon-setting"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">帳戶設定</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sub-merchant" class="level2">
            <div class="icon icon-sub-merchant"></div>
            <span :class="{'isSpanHidden' : isSpanHidden}">
              管理附屬帳戶
            </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/faq">
          <div class="icon icon-help"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">常見問題</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/tnc" target='_blank'>
          <div class="icon icon-tnc"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">使用條款</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <a target="_blank" href="/res/agc/tutorial.pdf">
          <div class="icon icon-tutorial"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">使用教學</span>
        </a>
      </li>
      <li @click="handleMenuSlide">
        <a target="_blank" href="mailto:ecoupon@ulifestyle.com.hk">
          <div class="icon icon-email"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">聯絡我們</span>
        </a>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/statistics">
          <div class="icon icon-chart"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            統計報告
          </span>
        </router-link>
      </li>
      <li @click="handleNotiMenuSlide">
        <router-link to="/notification">
          <div class="icon icon-notification"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">最新消息</span>
          <div v-if="isNewTag" class="new-tag"></div>
        </router-link>
      </li>
      <li @click="handleMenuSlide" v-if="!!user.communityId">
        <router-link to="/community">
          <div class="icon icon-community"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            U Lifestyle 社群
          </span>
        </router-link>
      </li>
      <li class="logout">
        <a v-stream:click="onLogout$">
          <div class="icon icon-logout"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">登出</span>
        </a>
      </li>
    </ul>
    <ul v-if="role === 'admin'">
      <li>
        <div class="menu">
          <div class="title">
            目錄
          </div>
          <div class="close">
            <b-icon-x @click="handleMenuSlide"></b-icon-x>
          </div>
        </div>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/home">
          <div class="icon icon-home"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">主頁</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/coupons">
          <div class="icon icon-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">積分優惠券</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/paidCoupons">
          <div class="icon icon-paid-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">付費優惠券</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/salesorder" class="level2">
          <div class="icon icon-order"></div>
          <span>銷售訂單</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/paymentRecords" class="level2">
          <div class="icon icon-cashout"></div>
          <span>收款狀態</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/merchants">
          <div class="icon icon-merchant"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            商戶
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/sales">
          <div class="icon icon-merchant"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            營銷人員
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/statistics">
          <div class="icon icon-chart"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            統計報告
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/notification">
          <div class="icon icon-notification"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            最新消息
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/admin/company-intro-templates">
          <div class="icon icon-template"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            公司簡介範本
          </span>
        </router-link>
      </li>
      <li class="logout">
        <a v-stream:click="onLogout$">
          <div class="icon icon-logout"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">登出</span>
        </a>
      </li>
    </ul>
    <ul v-if="role === 'sale'">
      <li>
        <div class="menu">
          <div class="title">
            目錄
          </div>
          <div class="close">
            <b-icon-x @click="handleMenuSlide"></b-icon-x>
          </div>
        </div>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/home">
          <div class="icon icon-home"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">主頁</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/coupons">
          <div class="icon icon-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">積分優惠券</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/paidCoupons">
          <div class="icon icon-paid-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">付費優惠券</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/salesorder" class="level2">
          <div class="icon icon-order"></div>
          <span>銷售訂單</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/paymentRecords" class="level2">
          <div class="icon icon-cashout"></div>
          <span>收款狀態</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/merchants">
          <div class="icon icon-merchant"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            商戶
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/faq">
          <div class="icon icon-help"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">常見問題</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/tnc" target='_blank'>
          <div class="icon icon-tnc"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">使用條款</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <a target="_blank" href="/res/agc/tutorial.pdf">
          <div class="icon icon-tutorial"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">使用教學</span>
        </a>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/statistics">
          <div class="icon icon-chart"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            統計報告
          </span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/sale/notification">
          <div class="icon icon-notification"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">
            最新消息
          </span>
        </router-link>
      </li>
      <li class="logout">
        <a v-stream:click="onLogout$">
          <div class="icon icon-logout"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">登出</span>
        </a>
      </li>
    </ul>
    <ul v-if="role === 'sub-merchant'">
      <li>
        <div class="menu">
          <div class="title">
            目錄
          </div>
          <div class="close">
            <b-icon-x @click="handleMenuSlide"></b-icon-x>
          </div>
        </div>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/qr-scanner/coupon">
          <div class="icon icon-coupon"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">現時可兌換優惠</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/qr-scanner/scan">
          <div class="icon icon-scan"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">掃描二維碼</span>
        </router-link>
      </li>
      <li @click="handleMenuSlide">
        <router-link to="/qr-scanner/scannedCoupons">
          <div class="icon icon-order"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">使用紀錄</span>
        </router-link>
      </li>
      <li class="logout">
        <a v-stream:click="onLogoutSubMerchant$">
          <div class="icon icon-logout"></div>
          <span :class="{'isSpanHidden' : isSpanHidden}">登出</span>
        </a>
      </li>
    </ul>
    <div class="mobile-mask" @click="handleMenuSlide"></div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { BIconX } from 'bootstrap-vue';
import { SET_MOBILE_MENU, SET_USER } from '../store/index';
import logoutMixin from '../mixins/logout';

export default {
  mixins: [logoutMixin],
  components: {
    BIconX,
  },
  computed: {
    ...mapState(['isMenuShrink']),
    ...mapState(['isMobileMenu']),
    ...mapState(['isSpanHidden']),
    ...mapState(['user']),
  },
  data() {
    return {
      isNewTag: false,
    };
  },
  methods: {
    getNewTag() {
      axios
        .get('/agc-merchant-api/notification/getNewTag')
        .then((isNewTag) => {
          const { publishOn } = isNewTag.data.payload;
          const readNewNotiAt = localStorage.getItem('readNewNotiAt');
          if (publishOn) {
            this.isNewTag = !readNewNotiAt
              || new Date(parseInt(readNewNotiAt, 10)) < new Date(publishOn);
          }
        })
        .catch()
        .finally();
    },
    handleMenuSlide() {
      this.$store.commit(SET_MOBILE_MENU);
    },
    handleNotiMenuSlide() {
      this.$store.commit(SET_MOBILE_MENU);
      localStorage.setItem('readNewNotiAt', Date.now());
      this.isNewTag = false;
    },
    logoutSubMerchant() {
      localStorage.clear();
      this.$store.commit(SET_USER, null);
      this.$router.push({ name: 'SubMerchantLogin' });
    },
  },
  mounted() {
    if (this.role === 'merchant') {
      this.getNewTag();
    }
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

.app-drawer {
  position: sticky;
  top: 0;
  padding-top: $toolbar-height;
  height: 100vh;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 240px;
  background: white;
  border-right: 1px solid #cdcdcd;
  overflow: hidden;
  transition: width 0.5s;
  border-right: 1px solid #EBEEF0;

  @media (min-width: 765px) and (max-width: 1024px) {
    & a {
      border-left: #fff !important;
    }
  }

  @include respond(tab-landscape) {
    display: none;
  }

  & ul {
    padding: 0;
    list-style: none;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    margin: 0;
    & li {
      border-bottom: 1px solid #EEEEF1;
      &.logout{
        margin-top: auto;
      }

      & span {
        position: relative;
        min-width: 120px;
        top: -5px;
      }

      & .isSpanHidden {
        display: none;
        @include respond(tab-landscape){
          display: inline-block;
        }
      }

      & .menu {
        display: none;
          @include respond(tab-landscape){
            display: inline-block;
            height: auto;
            text-align: center;
            position: relative;
            background: #F7FAFD;
            width: 100%;
            padding: 10px 0px;

            .title {
              display: inline-block;
              vertical-align: middle;
              color: #000;
              font-size: 18px;
              letter-spacing: 0;
              font-weight: 500;
              line-height: 30px;
              margin-bottom: 0px;
            }
        }
      }
      & a {
        width: 100%;
        height: 49px;
        box-sizing: border-box;
        display: inline-block;
        padding: 0.8rem 1.25rem;
        margin-left: 0;
        color: #3A4047;
        font-weight: 400;
        font-size: 15px;
        border-left: 4px solid #fff;
        cursor: pointer;

        &:hover {
          text-decoration: none;
        }
      }

      & .icon {
        margin-right: 20px;
        display: inline-block;
        position: relative;
        width: 22px;
        height: 23px;
      }

      & a.level2{
          padding-left:60px;
          @media (max-width: 1024px) {
            padding-left:20px;
          }
      }

      & .icon-coupon {
        background-image: url(../assets/img/icon/coupon.svg);
      }

      & .icon-order {
        background-image: url(../assets/img/icon/order.svg);
      }

      & .icon-cashout {
        background-image: url(../assets/img/icon/cashout.svg);
      }

      & .icon-paid-coupon {
        background-image: url(../assets/img/icon/paid-coupon.svg);
      }

      & .icon-setting {
        background-image: url(../assets/img/icon/setting.svg);
      }

      & .icon-help {
        background-image: url(../assets/img/icon/help.svg);
      }

      & .icon-tnc {
        background-image: url(../assets/img/icon/tnc.svg);
      }

      & .icon-tutorial {
        background-image: url(../assets/img/icon/tutorial.svg);
      }

      & .icon-email {
        background-image: url(../assets/img/icon/email.svg);
      }

      & .icon-merchant {
        width: 21px;
        background-image: url(../assets/img/icon/merchant.svg);
      }
      & .icon-sub-merchant {
        width: 21px;
        background-image: url(../assets/img/icon/merchant.svg);
      }

      & .icon-chart {
        width: 21px;
        background-image: url(../assets/img/icon/chart.svg);
      }

      & .icon-logout {
        width: 21px;
        background-image: url(../assets/img/icon/logout.svg);
      }
      & .icon-notification {
        width: 21px;
        background-image: url(../assets/img/icon/notification.svg);
      }
      & .icon-community {
        width: 21px;
        background-image: url(../assets/img/icon/community.svg);
      }
      & .icon-template {
        width: 21px;
        background-image: url(../assets/img/icon/template.svg);
      }
      & .icon-home {
        width: 21px;
        background-image: url(../assets/img/icon/home.svg);
      }
      & .icon-scan {
        width: 25px;
        height: 25px;
        margin-right: 17px;
        background-image: url(../assets/img/icon/scan.svg);
      }
      & .router-link-active {
        background: #F9F9FF;
        border-left: 4px solid #318CE1;
        font-weight: 500;
        color: #318ce1;

        & .icon-coupon {
          background-image: url(../assets/img/icon/coupon-active.svg);
        }

        & .icon-paid-coupon {
          background-image: url(../assets/img/icon/paid-coupon-active.svg);
        }

        & .icon-order {
          background-image: url(../assets/img/icon/order-active.svg);
        }

        & .icon-cashout {
          background-image: url(../assets/img/icon/cashout-active.svg);
        }

        & .icon-setting {
          background-image: url(../assets/img/icon/setting-active.svg);
        }

        & .icon-help {
          background-image: url(../assets/img/icon/help-active.svg);
        }

        & .icon-tnc {
          background-image: url(../assets/img/icon/tnc-active.svg);
        }

        & .icon-merchant {
          background-image: url(../assets/img/icon/merchant-active.svg);
        }
        & .icon-sub-merchant {
          background-image: url(../assets/img/icon/merchant-active.svg);
        }
        & .icon-chart {
          background-image: url(../assets/img/icon/chart-active.svg);
        }
        & .icon-notification {
          background-image: url(../assets/img/icon/notification-active.svg);
        }
        & .icon-community {
          background-image: url(../assets/img/icon/community-active.svg);
        }
        & .icon-template {
          background-image: url(../assets/img/icon/template-active.svg);
        }
        & .icon-home {
          background-image: url(../assets/img/icon/home-active.svg);
        }
        & .icon-scan {
          width: 26px;
          height:26px;
          margin-right: 16px;
          background-image: url(../assets/img/icon/scan.svg);
        }
      }
    }
  }
}

.menu-shrink {
  width: 65px;
  display: inline-block;
  & a.level2{
    padding-left:20px !important;
    span{
      display: none;
    }
  }

  & span {
    min-width: 0;
  }

  & a {
    border-left: #fff !important;
  }

  @include respond(tab-landscape) {
    display: none;
  }
}

.mobile-menu {
  @include respond(tab-landscape) {
    width: 80%;
    display: inline-block;
    position: fixed;
    z-index: 1001;
    padding-top: 0px;
    height: 100vh;
    overflow: auto;
    & .isSpanHidden {
      display: inline-block;
    }
    & a.level2 {
      padding-left: 60px !important;
      span {
        display: inline-block;
      }
    }

    .mobile-mask {
      width: 80%;
      position: fixed;
      top: 0;
      right: 0;
      height: 100vh;
      width: 20%;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}

.new-tag {
  background-image: url(../assets/img/icon/new-tag.svg);
  width: 22px;
  height: 11px;
  position: relative;
  top: -5px;
  margin-left:10px;
  display:inline-block;
}
</style>
